import { Component, ViewChild, OnInit, Input, Output, EventEmitter, ElementRef, Directive, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { ProjectsService } from './projects.service';
import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { NgStyle } from '@angular/common';
import { SharedService } from '../shared/shared.service';
import { AdvancedSearchChipsComponent } from '../search/chips/searchchips.component';

import * as globals from '../globals';

import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { ProjectDataService } from '../shared/dataservice.service';

import { UploadService } from '../shared/upload.service';
import { CommonService } from '../navbar/searchCommon.service';
import { Subscription } from 'rxjs/Subscription';

import { UtilsService } from '../shared/utils.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { NavbarService } from '../navbar/navbar.service';

import { S3CredService } from '../shared/s3-cred-service';

let UserInterface: any;
let HWV_CSR: any;
let unload: any;
let killPreviousViewer: any;
declare let openNewBrowserWindow: any;
declare let openNewBrowserWindow2: any;
let actions: any;


@Component({
  selector: 'app-projects',
  templateUrl: 'projects.component.html',
  styleUrls: ['projects.component.css'],
  providers: [ProjectsService, GetFileTypeService, S3CredService]
})


export class ProjectsComponent implements OnInit {

  // the variables below this comment were called in the HTML template but were causing the build to fail
  // materialEdit is currently called on line 95 and 403
  materialEdit: any;
  // customerEdit is currently called on line 433
  customerEdit: any;
  ownerEdit: any;

  // the variables above this comment were called in the HTML template but were causing the build to fail
  projects = [];
  private el: ElementRef;
  bucketname = globals.BUCKETNAME;
  // usagesizepercentage: string = '';
  // usagecount: number = 0;
  usagecountpercentage: string = '';
  // oversizelimit: boolean = false;
  // overcountlimit: boolean = false;

  errorMessage: string;
  filesToUpload: Array<File>;
  email = '';
  loadingprojects: boolean = true;
  searchInProgreess: boolean = false;
  uploadingproject: boolean = false;
  progressbarActive: boolean = false;
  projectloaderror: boolean = false;
  passwordmatchmessage: boolean = false;
  oldpasswordmessage: boolean = false;
  passwordrequiredmessage: boolean = false;
  passwordmodalcanceltitle: string = 'Cancel';
  passwordupdatesuccess: boolean = false;
  changepasswordicon = '';
  messagerequiredmessage: boolean = false;
  createButtonStatus: boolean = true;

  sharelink: string = '';
  sharefolder: string = '';
  sharefilename: string = '';
  shareprojectid: string = '';
  shareemail: string = '';
  sharesubject: string = '';
  sharemessage: string = '';
  shareErrorMessage: string = '';
  projectname: string;
  partnumber: string;
  revision: string;
  projectdescription: string;

  selectedassignee: string;

  translateprojectid: string = '';
  translatename: string = '';
  translatefilename: string = '';
  translatetype: string = 'stp';
  // Refactor
  // lets offload this to a supportive service
  // 0=loading, 1=file not present, 2=file present
  translatePDF: number = 0;
  translateSTP: number = 0;
  translateSTL: number = 0;
  isProcessingCount: number = 0;
  translatetimer: any;
  translatetimerlength: number = 10000;
  selectedMaterialID: number;
  materialselectSearch: number;
  ownerselect: number;
  ownerselectSearch: number;
  selectedCustomerID: number;
  customerselectSearch: number;
  customerselectSearchString: string;
  materialselectSearchString: string;
  ownerSelectSearchString: string;
  statusSelectSearchString: string;
  dateRangeString: string;
  statusselect: number;
  statusselectSearch: number;
  numberofDaysSearch: number;
  materialArray: any = [];
  materialDict: any = {};
  ownerArray: any = [];
  ownerDict: any = {};
  ownerEmailDict: any = {};
  customerArray: any = [];
  customerDict: any = {};
  statusArray: any = [];
  statusDict: any = {};
  DateRangeArray: any = ['1 week', '2 weeks', '1 month', '2 months', '6 months', '1 year'];
  uploadCurrentValue: number;
  emptySearchProjects: boolean;
  noProjects: boolean;
  noresultsmessage: string = 'No Project Name, Part Number or Revision contains:';

  noresultsmessageAdvancedSearch: string = 'No Project found with above search terms';

  OwnerSearch: number;
  MaterialSearch: number;
  StatusSearch: number;
  dateRangeSearch: number;
  CustomerSearch: string = '';
  PartNumberSearch: string = '';
  RevisionSearch: string = '';
  currentControl: any;
  ProjectNameSearch: string;
  createdDateSearch: string;
  waiticon = '';
  createProjectBtnDisable = true;
  showUpload = true;
  public progresses: any = [];

  public filteredOwnerList = [];
  public chipArray = [];
  public elementRef;
  public dateFormat: string;

  linkchars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  tenantid: string = '';
  planid: string;
  _service: any;
  _projectDataService: any;
  hwv: any;
  userInterface: any;
  timer: any;
  timerlength: number = 10000;
  projectforceUpdate = false;
  tenanturl: string = '';
  private subscription: Subscription;

  // Pagination
  public filter: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public config = {
    itemsPerPage: 25,
    currentPage: 1,
    totalItems: 1
  };

  public searchTerms: string = '';
  public advancedSearchJSONbody: any;
  haveAdvancedSearch: boolean = false;
  ContextOwnerID: number;
  advSearchState: number = 0;
  noMoreData = false;
  onQuotesPage = false;


  modalDeleteProjectAction = new EventEmitter<string | MaterializeAction>();
  modalNewProjectAction = new EventEmitter<string | MaterializeAction>();
  modalShareModelAction = new EventEmitter<string | MaterializeAction>();
  modalShowTranslateAction = new EventEmitter<string | MaterializeAction>();
  modalAdvancedSearchProjectsAction = new EventEmitter<string | MaterializeAction>();
  modalAdvancedSearchProjectsAction2 = new EventEmitter<string | MaterializeAction>();
  projectToDelete: any = { id: 0, name: '' };

  @Input() id;
  @Output() actions: EventEmitter<string> = new EventEmitter<string>();
  @Output() quoteAddProject: EventEmitter<string> = new EventEmitter<string>();

  constructor(private projectsService: ProjectsService,
    private router: Router,
    private http: Http,
    private service: SharedService,
    private projectDataService: ProjectDataService,
    private uploadService: UploadService,
    myElement: ElementRef,
    private commonService: CommonService,
    private _el: ElementRef,
    private utilsService: UtilsService,
    private getFileTypeService: GetFileTypeService,
    public navService: NavbarService
  ) {
    this._service = service;
    this._projectDataService = projectDataService;
    this.elementRef = myElement;
    console.log('SERVICE:', service);
    this.el = this._el;
  }

  ngOnInit() {

    if (this.router.url.match('quote')) {
      this.onQuotesPage = true;
    } else if (this.router.url !== '/workspace') {
      this.navService.show('PROJECTS');
      this.navService.setNavID(1);
    }

    this.planid = localStorage.getItem('mr_planid');
    this.dateFormat = localStorage.getItem('mr_date_format_id');
    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    this.tenantid = localStorage.getItem('mr_tenantid');
    this.email = localStorage.getItem('mr_email');
    this.planid = localStorage.getItem('mr_planid');

    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    console.log('TENANTURL:', this.tenanturl);
    console.log('EMAIL:', this.email);
    this.selectedassignee = this.email;
    this.emptySearchProjects = false;
    this.noProjects = false;
    if (this.planid === '1') {
      this.router.navigate(['/bernie']);

    }

    this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
      if (res.hasOwnProperty('option') && res.option === 'onSearchFromNav') {
        if (res.value.page === 'projects') {
          this.projects = [];
          this.config.currentPage = 1;
          this.loadingprojects = true;
          delete this.advancedSearchJSONbody;
          this.haveAdvancedSearch = false;
          this._projectDataService.setForceUpdateBool(true);
          if (res.value.data !== '') {
            this.searchTerms = res.value.data;
            this.advancedSearchJSONbody = { name: res.value.data, number: res.value.data, revision: res.value.data, advancedSearch: 0};
          }
          this.reloadProjectsPage();
        }
      } else {
        if (res.hasOwnProperty('option') && res.option === 'onAdvancedSearch') {
          if ( res.value.page === 'projects') {
            this.projects = [];
            this.config.currentPage = 1;
            this.haveAdvancedSearch = true;
            this.loadingprojects = true;

            if (res.value.data != '') {
              this.advancedSearchJSONbody = res.value.data;
              this.advancedSearchJSONbody.advancedSearch = 1;
            } else {
              delete this.advancedSearchJSONbody;
            }

            this._projectDataService.setForceUpdateBool(true);
            this.reloadProjectsPage();
          }
        }
      }
    });

    this.service.getCorporateInfo().subscribe(
      data => {
        let jdata = JSON.parse(data);
        this.customerArray = jdata.customers;
        this.materialArray = jdata.materials;
        this.ownerArray = jdata.owners;
        this.statusArray = jdata.statuses;

        for (let i = 0; i < this.materialArray.length; i++) {
          this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
        }

        this.email = localStorage.getItem('mr_email');
        for (let i = 0; i < this.ownerArray.length; i++) {
          this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].firstname + ' ' + this.ownerArray[i].lastname;
          this.ownerEmailDict[this.ownerArray[i].id] = this.ownerArray[i].email;
          if (this.email === this.ownerArray[i].email) {
            this.ContextOwnerID = this.ownerArray[i].id;
          }
        }

        for (let i = 0; i < this.customerArray.length; i++) {
          this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
        }

        for (let i = 0; i < this.statusArray.length; i++) {
          this.statusDict[this.statusArray[i].id] = this.statusArray[i].name;
        }

        console.log('Materials:', this.materialArray);
        console.log('Owners:', this.ownerArray);
        console.log('Customers:', this.customerArray);
        console.log('status', this.statusArray);

        if (this.router.url === '/workspace') {
          this.service.setProjectSearchResultBool(true);
          this.service.setSearchResultData('projects', {owner : this.ContextOwnerID});
          document.getElementById('projectList').style.marginTop = '-50px';
          document.getElementById('projectList').style.paddingLeft = '0px';
          document.getElementById('projectList').style.width = '100%';

          this._service.setProjectSearchResultBool(false);
          this.commonService.notifyOther({ option: 'getPageSearchData', value: 'projects'});

        } else {
          if ( this.router.url.match('quote')) {
            document.getElementById('projectList').style.marginTop = '-50px';
            document.getElementById('projectList').style.paddingLeft = '0px';
            document.getElementById('projectList').style.width = '100%';
          }

          let timer = Observable.timer(1500); // Delay to get search chip showing when coming from a different page
          timer.subscribe(t => {
            // check if this page was loaded by a search query
            if (this._service.getProjectSearchResultBool()) {
              this._service.setProjectSearchResultBool(false);
              this.commonService.notifyOther({ option: 'getPageSearchData', value: 'projects'});
            } else {
              this.reloadProjectsPage();
            }
          });
      }
      }, error => {

      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.modalDeleteProjectAction.emit({ action: 'modal', params: ['close'] });
    this.modalNewProjectAction.emit({ action: 'modal', params: ['close'] });
    this.modalShareModelAction.emit({ action: 'modal', params: ['close'] });
    this.modalShowTranslateAction.emit({ action: 'modal', params: ['close'] });
    this.modalAdvancedSearchProjectsAction.emit({ action: 'modal', params: ['close'] });
  }

  reloadProjectsPage() {
    console.log('in reloadProjectsPage', this.advancedSearchJSONbody);
    this.projectforceUpdate = this._projectDataService.getForceUpdateBool();
    this.projectsService.getProjects(this.projectforceUpdate,
          this.config.currentPage,
          this.config.itemsPerPage,
          globals.ProjectType.PROJECT,
          this.advancedSearchJSONbody)
      .subscribe(
      data => {
        console.log('Got projects');
        if (Object.keys(data).length === 0) {
          // Credential ERROR
          this.loadingprojects = false;
          this.projectloaderror = true;
        } else {
          // TODO: Account for a response of 'Process exited before completing request'
          //      or have API Gateway massage this response
          let projectdata = JSON.parse(data);

          this.config.currentPage = Number(projectdata.pagenum);
          this.config.totalItems = projectdata.count;

          if (!projectdata.projects.length && !this.advancedSearchJSONbody) {
            this.noProjects = true;
          } else if (!projectdata.projects.length ) {
            this.emptySearchProjects = true;

          } else {
            this.noProjects = false;
            this.emptySearchProjects = false;
          }

          // This needs to be out here so that the other data can be loaded,
          // like the customer and materials data
          this._projectDataService.setForceUpdateBool(false);
          this.refreshProjects(data);

        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        this.loadingprojects = false;
        this.projectloaderror = true;
      });
  }

  refreshProjects(data) {
    let projectdata = JSON.parse(data);
    console.log('refreshProjects');
    console.log(projectdata);

    let isProcessing = false;

    // Populate the thumbnail URLs
    for (let key in projectdata.projects) {
      // Determine the status of the model file to show
      if (projectdata.projects.hasOwnProperty(key)) {
        if (projectdata.projects[key].upload_status == 1) {
          isProcessing = true;
        }

        let filenamenoext = ' ';

        // Get the filename extension
        projectdata.projects[key].extension = '';
        if (projectdata.projects[key].filename != null) {
          projectdata.projects[key].extension = projectdata.projects[key].filename.split('.').pop();

          // Get the filename without the extension
          filenamenoext = projectdata.projects[key].filename.replace(/\.[^/.]+$/, '');
          filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
        }

        if (projectdata.projects[key].material_id == null || projectdata.projects[key].material_id == 'undefined') {
          projectdata.projects[key].material_id = 0;
        }

        projectdata.projects[key].status_id = 0;
        projectdata.projects[key].filenamenoext = filenamenoext;

        projectdata.projects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_320x240.png';

        let modeltype = this.utilsService.determineModelType(projectdata.projects[key].filename);

        if (projectdata.projects[key].modeltype_id == 0 && modeltype != 0) {
          projectdata.projects[key].modeltype_id = modeltype;
        }

        if (modeltype != 0) {
          projectdata.projects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_320x240.png';
        } else {
          let ext = projectdata.projects[key].extension.toLowerCase();
          console.log('EXTENSION:', ext);
          projectdata.projects[key].thumbnail = this.getFileTypeService.returnFileTypeExtensionURLAppend96(ext);
        }

        let val = projectdata.projects[key];
      }

      // Determine the Part Type to show
      projectdata.projects[key].cardparttype = this.utilsService.getModelName(projectdata.projects[key].modeltype_id);
      console.log('projects', this.projects);

      this.projects.push(projectdata.projects[key]);
    }

    // Check if there are more projects to load
    if (this.projects.length == projectdata.count) {
      this.noMoreData = true;
    } else {
      this.noMoreData = false;
    }

    this.loadingprojects = false;

    // See if any of the projects are in a processing state.  If so
    // start a timer to check the backend for them to be completed.
    if (isProcessing) {
      console.log('Detected a project in the processing state');
      this.timer = Observable.timer(this.timerlength);
      this.timer.subscribe(t => this.checkProcessingStatus());
    }
  }

  loadMoreProjects() {
    this.config.currentPage += 1;
    this.loadingprojects = true;

    this.projectsService.getProjects(true,
          this.config.currentPage,
          this.config.itemsPerPage,
          globals.ProjectType.PROJECT,
          this.advancedSearchJSONbody)
      .subscribe(
      data => {
        console.log('Got projects');
        if (Object.keys(data).length === 0) {
          // Credential ERROR
          this.loadingprojects = false;
          this.projectloaderror = true;
        } else {
          // TODO: Account for a response of 'Process exited before completing request'
          //      or have API Gateway massage this response
          let projectdata = JSON.parse(data);
          this.config.currentPage = Number(projectdata.pagenum);

          this._projectDataService.setForceUpdateBool(false);
          this.refreshProjects(data);
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        this.loadingprojects = false;
        this.projectloaderror = true;
      });

  }

  editProjectRow(index) {
    document.getElementById('name' + index).style.display = 'none';
    document.getElementById('nameEdit' + index).style.display = 'block';

    document.getElementById('number' + index).style.display = 'none';
    document.getElementById('numberEdit' + index).style.display = 'block';

    document.getElementById('revision' + index).style.display = 'none';
    document.getElementById('revisionEdit' + index).style.display = 'block';

    document.getElementById('material' + index).style.display = 'none';
    document.getElementById('materialEdit' + index).style.display = 'block';

    document.getElementById('customername' + index).style.display = 'none';
    document.getElementById('customernameEdit' + index).style.display = 'block';

    document.getElementById('owner' + index).style.display = 'none';
    document.getElementById('ownerEdit' + index).style.display = 'block';

    document.getElementById('status' + index).style.display = 'none';
    document.getElementById('statusEdit' + index).style.display = 'block';

    document.getElementById('projectEdit' + index).style.display = 'none';
    document.getElementById('projectSave' + index).style.display = 'block';
    document.getElementById('projectCancel' + index).style.display = 'block';
    document.getElementById('projectDropDownIcon' + index).style.display = 'none';

    this.selectedMaterialID = this.projects[index].material_id;
    this.selectedCustomerID = this.projects[index].customer_id;
    this.ownerselect = this.projects[index].assigned_id;
    this.statusselect = this.projects[index].status_id;
  }

  cancelProjectRow(index) {
    document.getElementById('name' + index).style.display = 'block';
    document.getElementById('nameEdit' + index).style.display = 'none';

    document.getElementById('number' + index).style.display = 'block';
    document.getElementById('numberEdit' + index).style.display = 'none';

    document.getElementById('revision' + index).style.display = 'block';
    document.getElementById('revisionEdit' + index).style.display = 'none';

    document.getElementById('material' + index).style.display = 'block';
    document.getElementById('materialEdit' + index).style.display = 'none';

    document.getElementById('customername' + index).style.display = 'block';
    document.getElementById('customernameEdit' + index).style.display = 'none';

    document.getElementById('owner' + index).style.display = 'block';
    document.getElementById('ownerEdit' + index).style.display = 'none';

    document.getElementById('status' + index).style.display = 'block';
    document.getElementById('statusEdit' + index).style.display = 'none';

    document.getElementById('projectEdit' + index).style.display = 'block';
    document.getElementById('projectSave' + index).style.display = 'none';
    document.getElementById('projectCancel' + index).style.display = 'none';
    document.getElementById('projectDropDownIcon' + index).style.display = 'block';

  }

  onMaterialChange(id) {
    console.log('Selected material ID', id);
    this.selectedMaterialID = id;
    this.materialselectSearch = Number(id);
    this.materialselectSearchString = id;
  }

  onOwnerChange(value) {
    console.log('owner value', value);
    this.ownerselect = value;
    this.ownerselectSearch = Number(value);
    this.ownerSelectSearchString = value;
  }

  onCustomerChange(id) {
    console.log('Selected customer ID', id);
    this.selectedCustomerID = id;
    this.customerselectSearch = Number(id);
    this.customerselectSearchString = id;
  }

  onStatusChange(value) {
    console.log('Status value', value);
    this.statusselect = value;
    this.statusselectSearch = Number(value);
    this.statusSelectSearchString = value;
  }

  onDateChangeSearch(value) {

    let res = value.split('-');
    if (res.length = 3) {
      this.createdDateSearch = res[1] + '/' + res[2] + '/' + res[0];
    } else {
      this.createdDateSearch = '';
    }
  }

  saveProjectRow(index) {

    document.getElementById('name' + index).style.display = 'block';
    document.getElementById('nameEdit' + index).style.display = 'none';
    this.projects[index].name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

    document.getElementById('number' + index).style.display = 'block';
    document.getElementById('numberEdit' + index).style.display = 'none';
    this.projects[index].number = (<HTMLInputElement>document.getElementById('numberEdit' + index)).value;

    document.getElementById('revision' + index).style.display = 'block';
    document.getElementById('revisionEdit' + index).style.display = 'none';
    this.projects[index].revision = (<HTMLInputElement>document.getElementById('revisionEdit' + index)).value;

    document.getElementById('material' + index).style.display = 'block';
    document.getElementById('materialEdit' + index).style.display = 'none';
    this.projects[index].material_id = Number(this.selectedMaterialID);

    document.getElementById('customername' + index).style.display = 'block';
    document.getElementById('customernameEdit' + index).style.display = 'none';
    this.projects[index].customer_id = Number(this.selectedCustomerID);

    document.getElementById('owner' + index).style.display = 'block';
    document.getElementById('ownerEdit' + index).style.display = 'none';
    this.projects[index].assigned_id = Number(this.ownerselect);

    document.getElementById('status' + index).style.display = 'block';
    document.getElementById('statusEdit' + index).style.display = 'none';
    this.projects[index].status = this.statusselect;

    document.getElementById('projectEdit' + index).style.display = 'none';
    document.getElementById('projectSave' + index).style.display = 'none';
    document.getElementById('projectCancel' + index).style.display = 'none';
    document.getElementById('projectSpinner' + index).style.display = 'block';


    // To implement a code to get their actual ids by collecting arrays in dictionary objects

    let updateProjectdetails = {
      name: this.projects[index].name,
      number: this.projects[index].number,
      revision: this.projects[index].revision,
      description: this.projectdescription,
      material_id: this.projects[index].material_id,
      assigned_id: this.projects[index].assigned_id,
      customer_id: this.projects[index].customer_id,
      status: this.projects[index].status
    };

    // Create the project to be able to get the project ID
    this.projectsService.updateProject(this.projects[index].id, updateProjectdetails)
      .subscribe(
      data => {
        console.log('PROJECT UPDATED SUCCESSFULLY', data);
        Materialize.toast('PROJECT UPDATED SUCCESSFULLY.', 1500);
        this._projectDataService.setForceUpdateBool(true);
        // set back the icon displays
        document.getElementById('projectEdit' + index).style.display = 'block';
        document.getElementById('projectSave' + index).style.display = 'none';
        document.getElementById('projectCancel' + index).style.display = 'none';
        document.getElementById('projectSpinner' + index).style.display = 'none';
        document.getElementById('projectDropDownIcon' + index).style.display = 'block';

      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
      });

  }

  checkProcessingStatus() {
    let processingCount;
    this.projectsService.processingUploadCheck()
      .subscribe(
      data => {
        console.log('checkProcessingStatus');
        let processingdata = JSON.parse(data);
        processingCount = processingdata.length;
        if (processingdata.length == 0 || processingCount < this.isProcessingCount) {
          // No projects processing, so refresh the data
          console.log('No projects in a processing state');
          // quick fix for getting rid of duplicate line items appearing when dealing with projects in translation
          this.config.currentPage = 1;
          this.projects = [];
          this.projectsService.getProjects(true,
                this.config.currentPage,
                this.config.itemsPerPage,
                globals.ProjectType.PROJECT,
                this.advancedSearchJSONbody)
            .subscribe(
            data => {
              if (Object.keys(data).length === 0) {
                // Credential ERROR
                this.loadingprojects = false;
              } else {
                let projectdata = JSON.parse(data);

                this._projectDataService.setForceUpdateBool(false);
                this.refreshProjects(data);
              }
            },
            error => {
              this.errorMessage = <any>error;
              console.error('getProjects() error:', this.errorMessage);
              this.loadingprojects = false;
              // this.projectloaderror = true;
            });
        } else {
          // Start the timer again
          console.log('Project(s) are in a processing state');
          this.isProcessingCount = processingCount;
          this.timer = Observable.timer(this.timerlength);
          this.timer.subscribe(t => this.checkProcessingStatus());
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('checkProcessingStatus() error:', this.errorMessage);
      });
  }

  onProjectDeleteComplete() {
    this.loadingprojects = true;
    this._projectDataService.setForceUpdateBool(true);
    this.reloadProjectsPage();
  }

  getKeyByValue(dictionary, value) {
    for (let i in dictionary) {
      if (dictionary.hasOwnProperty(i)) {
        if (dictionary[i] === value) {
          return i;
        }
      }
    }
  }

  ProjectInfoClicked() {
    this.showUpload = true;
  }

  ProjectAttachmentClicked() {
    this.showUpload = false;
  }

  checkEmptyField() {
    if (this.projectname && this.partnumber && this.revision) {
      this.createButtonStatus = false;
    } else {
      this.createButtonStatus = true;
    }
  }

  addIndicatorStyle() {
    $('#modalNewProject').find('.indicator').attr('style', 'right: 50%; left: 0px;');
  }

  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    // this.router.navigate(['/viewer']);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  OpenPDFView(project) {
    let PDFurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + project.id + '/' + project.name + '.pdf';
    // localStorage.setItem('saved_pdfurl', PDFurl);
    // window.open('/#/pdfviewer');
    // this.router.navigate(['/pdfviewer']);
    // window.open(PDFurl, '_blank');

    let myNewTab = window.open();

    this.projectsService.downloadPDF(PDFurl).subscribe(
      (res) => {
        let fileURL = URL.createObjectURL(res);
        myNewTab.location.href = fileURL;
        // window.open(fileURL);
      }
    );
  }

  onProjectUpload() {
  // quick fix for getting rid of duplicate line items appearing when dealing with projects in translation
  this.config.currentPage = 1;
  this.projects = [];

    this._projectDataService.setForceUpdateBool(true);
    this.reloadProjectsPage();
  }

  addToSelectedQuote(index: number, project: any) {

    let data = { index: index, project: project };

    this.quoteAddProject.emit(JSON.stringify(data));
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/projects/projects.component.ts